import * as actions from "../catalogActions";

export default function getData(matchedRoute) {
  return (dispatch, getState) => {
    const { fw, fp, fr, rw, rp, rr } = matchedRoute.params;

    actions.getLimitedTimeOffers()(dispatch);

    return actions.searchTirePairsByDimensions(
      { width: fw, profile: fp, rim: fr },
      { width: rw, profile: rp, rim: rr }
    )(dispatch, getState);
  };
}
